import { render, staticRenderFns } from "./WidgetItem.vue?vue&type=template&id=3d815d9f&scoped=true"
import script from "./WidgetItem.vue?vue&type=script&lang=js"
export * from "./WidgetItem.vue?vue&type=script&lang=js"
import style0 from "./WidgetItem.vue?vue&type=style&index=0&id=3d815d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d815d9f",
  null
  
)

export default component.exports